<script>
  export let fill="#000000";
  export let height="16px";
  export let width="16px";
  export let padding = "1em";

</script>
<div style="padding: {padding};" aria-hidden="true" >
  <svg fill={fill} width="{width}" height="{height}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>accessibility-circle-solid</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width="48" height="48" fill="none"/>
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <path d="M24,2A22,22,0,1,0,46,24,21.9,21.9,0,0,0,24,2Zm0,8a3,3,0,1,1-3,3A2.9,2.9,0,0,1,24,10ZM35,21H28v4.8l2,9.8A2.1,2.1,0,0,1,28.4,38H28a2.1,2.1,0,0,1-2-1.6L24.2,27h-.4L22,36.4A2.1,2.1,0,0,1,20,38h-.4A2.1,2.1,0,0,1,18,35.6l2-9.8V21H13a2,2,0,0,1,0-4H35a2,2,0,0,1,0,4Z"/>
      </g>
    </g>
  </svg>
</div>